// AGC: Admin theme toggle button — moon/sun icon, uses shared useTheme()
import React from 'react'
import { Moon, Sun } from 'lucide-react'
import { useTheme } from '../../../context/ThemeContext'

export const AdminThemeToggle: React.FC = () => {
  const { isDark, toggleTheme } = useTheme()

  return (
    <button
      onClick={toggleTheme}
      className={`
        w-8 h-8 flex items-center justify-center rounded-lg transition-colors
        bg-white border border-slate-200 text-brand-primary hover:bg-slate-50
        dark:bg-admin-card-dark dark:border-white/5 dark:text-brand-light dark:hover:bg-white/5
      `.replace(/\s+/g, ' ').trim()}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
    </button>
  )
}
